module.exports = __webpack_public_path__ + "img/icon-plane-white.3f5555e2.svg";